export enum LogicalOperators {
  AND = '-AND',
  OR = '-OR',
  NOT = '-NOT'
}
